import _Box from "@material-ui/core/esm/Box";
import _Typography from "@material-ui/core/esm/Typography";
const _excluded = ["searchQuery"];
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var defaultProps = type && type.defaultProps, childrenLength = arguments.length - 3; if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) { for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3]; props.children = childArray; } if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { messages } from "./TableMessages"; // material

function SearchNotFound(_ref) {
  let _ref$searchQuery = _ref.searchQuery,
      searchQuery = _ref$searchQuery === void 0 ? '' : _ref$searchQuery,
      other = _objectWithoutProperties(_ref, _excluded);

  const _useIntl = useIntl(),
        f = _useIntl.formatMessage;

  return React.createElement(_Box, other, _jsx(_Typography, {
    gutterBottom: true,
    align: "center",
    variant: "body1",
    style: {
      fontWeight: 'bold'
    }
  }, void 0, f(searchQuery !== '' ? messages.notFoundTitle : messages.empty)), _jsx(_Typography, {
    variant: "body2",
    align: "center"
  }, void 0, searchQuery !== '' && React.createElement(React.Fragment, null, f(messages.notResultsFor), _jsx("strong", {}, void 0, "\"", searchQuery, "\""), ".", f(messages.notFoundRetry))));
}

export { SearchNotFound };